import { useEffect, useState } from 'react';
import axios from 'axios';
import React, { Component } from 'react';


import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import CanvasJSReact from '@canvasjs/react-charts';
//var CanvasJSReact = require('@canvasjs/react-charts');


import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Scatter } from 'react-chartjs-2';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);


var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
// Function to generate random colors
function generateRandomColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}


const ScatterChart = ({ gridData, selectedCombinedScatterColumns, verticalScatterLabel,
    horizantalScatterLabel, scatterRightList, connectionNameValue, reportName,
    catalogs, schemas, tables, columns, xandLabelScatterColumns }) => {

    // alert(JSON.stringify(selectedCombinedLineColumns)+"--"+JSON.stringify(verticalLineLabel)+"--"+JSON.stringify(horizantalLineLabel)+"--"+JSON.stringify(lineRightList));
    const navigate = useNavigate();
    const location = useLocation();
    const [iframeUrl, setIframeUrl] = useState('');
    console.log(JSON.stringify(location.state) + "location.state--------------");

    let selectedCombinedScatterColumnsValue = [];
    let verticalScatterLabelValue = '';
    let horizantalScatterLabelValue = '';
    let scatterRightListValue = '';
    let connectionName = '';
    let reportNameValue = '';
    let gridDataValue = '';

    let catalogsList = '';
    let schemasList = '';
    let tablesList = '';
    let columnsList = '';
    let xandLabelScatterColumnsValue = [];


    const [scatterDataSet, setScatterDataSet] = useState([]);
    const [xaxis, setXaxis] = useState([]);
    const [yaxis, setYaxis] = useState([]);

    if (location.state && location.state.selectedCombinedScatterColumns !== undefined) {
        const { gridData, selectedCombinedScatterColumns, verticalScatterLabel,
            horizantalScatterLabel, scatterRightList, connectionNameValue, reportName,
            catalogs, schemas, tables, columns, xandLabelScatterColumns } = location.state;

        console.log(selectedCombinedScatterColumns); // Output: "name"
        console.log(verticalScatterLabel); // Output: "id"
        console.log(horizantalScatterLabel); // Output: "Name Only"
        console.log(scatterRightList); // Output: "Name Only"

        selectedCombinedScatterColumnsValue = location.state.selectedCombinedScatterColumns;
        verticalScatterLabelValue = location.state.verticalScatterLabel;
        horizantalScatterLabelValue = location.state.horizantalScatterLabel;
        scatterRightListValue = location.state.scatterRightList;
        connectionName = connectionNameValue;
        reportNameValue = reportName;
        gridDataValue = gridData;

        catalogsList = location.state.catalogs;
        schemasList = location.state.schemas;
        tablesList = location.state.tables;
        columnsList = location.state.columns;
        xandLabelScatterColumnsValue = xandLabelScatterColumns;


        console.log(JSON.stringify(selectedCombinedScatterColumnsValue) + "selectedCombinedLineColumnsValueLOC"
            + JSON.stringify(verticalScatterLabelValue) + "verticalLabelValueLOC"
            + JSON.stringify(horizantalScatterLabelValue) + "horizantalLineLabelValueLOC"
            + JSON.stringify(scatterRightListValue) + "lineRightListValueLOC");
    } else {

        selectedCombinedScatterColumnsValue = selectedCombinedScatterColumns;
        verticalScatterLabelValue = verticalScatterLabel
        horizantalScatterLabelValue = horizantalScatterLabel;
        scatterRightListValue = scatterRightList;
        connectionName = connectionNameValue;
        reportNameValue = reportName;
        gridDataValue = gridData;


        catalogsList = catalogs;
        schemasList = schemas;
        tablesList = tables;
        columnsList = columns;

        xandLabelScatterColumnsValue = xandLabelScatterColumns;

        console.log(JSON.stringify(selectedCombinedScatterColumnsValue) + "selectedCombinedLineColumnsValue");
        console.log(JSON.stringify(verticalScatterLabelValue) + "verticalLineLabelValue");
        console.log(JSON.stringify(horizantalScatterLabelValue) + "horizantalLineLabelValue");
        console.log(JSON.stringify(scatterRightListValue) + "lineRightListValue"
            + JSON.stringify(selectedCombinedScatterColumnsValue) + "selectedCombinedLineColumnsValue"
            + JSON.stringify(verticalScatterLabelValue) + "verticalLineLabelValue"
            + JSON.stringify(horizantalScatterLabelValue) + "horizantalLineLabelValue");
    }


    const handleClick = () => {
        console.log('Line chart clicked!');

        navigate('/scatterChart', {
            state: {
                selectedCombinedScatterColumns, verticalScatterLabel, horizantalScatterLabel, scatterRightList,
                connectionName, reportNameValue
            }
        });
        // navigate(`/pieChart?selectedCombinedColumns=${selectedCombinedColumns}&selectedIdsCombinedColumns=${selectedIdsCombinedColumns}&selectedLabelType=${selectedLabelType}`);
        //  const urlWithParams = `/pieChart?selectedCombinedColumns=${selectedCombinedColumns}&selectedIdsCombinedColumns=${selectedIdsCombinedColumns}&selectedLabelType=${selectedLabelType}`;
        //  setIframeUrl(urlWithParams);
    };

    console.log(JSON.stringify(selectedCombinedScatterColumnsValue) + "selectedCombinedScatterColumnsValue");
    console.log(JSON.stringify(verticalScatterLabelValue) + "verticalScatterLabelValue");
    console.log(JSON.stringify(horizantalScatterLabelValue) + "horizantalScatterLabelValue");
    console.log(JSON.stringify(scatterRightListValue) + "scatterRightListValue");




    const [data, setData] = useState({
        labels: [],
        datasets: [],
    });
    useEffect(() => {


        const datasets = [];

        if (xandLabelScatterColumnsValue && xandLabelScatterColumnsValue.length > 0) {
            xandLabelScatterColumnsValue.forEach((column) => {
                // Check if the column is present in rightListValue
                if (scatterRightListValue.includes(column)) {
                    const columnIndex = xandLabelScatterColumnsValue.indexOf(column);
                    const dataset = gridDataValue.map((data) => ({
                        y: parseInt(data[columnIndex], 10),
                        label: data[xandLabelScatterColumnsValue.indexOf(selectedCombinedScatterColumnsValue)],
                        color: generateRandomColor()
                    }));

                    // Create an object for the dataset and set its properties
                    const datasetObject = {
                        type: "scatter", // Set the chart type to column/bar
                        dataPoints: dataset,
                        markerSize: 15,
                        // Add other options as needed
                        // For example:
                        name: column, // Set the dataset name to the column name
                        showInLegend: true, // Show the dataset in the legend
                    };

                    datasets.push(datasetObject);



                }
            });
            console.log(JSON.stringify(datasets) + "datasets");
            setScatterDataSet(datasets);
            console.log(JSON.stringify(scatterDataSet) + "scatterDataSet");


        }





        // const datasets = gridDataValue.map(data => ({
        //     y: parseInt(data[1], 10),
        //     label: data[0],
        //     color: generateRandomColor()
        // }));
        // setScatterDataSet(datasets);

    },
        [selectedCombinedScatterColumnsValue, verticalScatterLabelValue, horizantalScatterLabelValue, scatterRightListValue])

    console.log(JSON.stringify(scatterDataSet) + "scatterdatasetOUT");
    const options = {
        exportEnabled: true,
        animationEnabled: true,
        zoomEnabled: true,
        title: {
            text: "Scatter Chart"
        },
        axisX: {
            title: "",
            // suffix: "°C",
            crosshair: {
                enabled: true,
                snapToDataPoint: true
            }
        },
        axisY: {
            title: "Sales",
            crosshair: {
                enabled: true,
                snapToDataPoint: true
            }
        },
        data: scatterDataSet
        // data: [{
        //     type: "scatter",
        //     markerSize: 15,
        //     toolTipContent: "{x} : {y}",
        //     dataPoints: scatterDataSet
        // dataPoints: [
        // 	{ x: 14.2, y: 215},
        // 	{ x: 12.9, y: 175},
        // 	{ x: 16.4, y: 325},
        // 	{ x: 26.9, y: 635},
        // 	{ x: 32.5, y: 464},
        // 	{ x: 22.1, y: 522},
        // 	{ x: 19.4, y: 412},
        // 	{ x: 25.1, y: 614},
        // 	{ x: 34.9, y: 374},
        // 	{ x: 28.7, y: 625},
        // 	{ x: 23.4, y: 544},
        // 	{ x: 31.4, y: 502},
        // 	{ x: 40.8, y: 262},
        // 	{ x: 37.4, y: 312},
        // 	{ x: 42.3, y: 202},
        // 	{ x: 39.1, y: 302},
        // 	{ x: 17.2, y: 408}
        // ]
        // }]
    }

    return (
        <div className="chart" style={location.state ? { width: '98%', height: '450px' } : { width: '50%', height: '300px' }}>
            {location.state && location.state.selectedCombinedScatterColumns !== undefined ? (
                <>
                    {/* <h2>Connection Name : {connectionName}</h2> */}
                    {/* <h3>Report Name : {reportNameValue}</h3> */}

                    <Link to="/QueryBuilder" state={{
                        connectionName: connectionName, reportName: reportNameValue,
                        catalogs: catalogsList,
                        schemas: schemasList,
                        tables: tablesList,
                        columns: columnsList
                    }}>Home</Link>
                    <CanvasJSChart data={data} options={options} />
                </>

            ) : (
                <CanvasJSChart data={data} className="left-align" options={options} onClick={() => handleClick()} />
            )}
        </div>
    )

}
export default ScatterChart; 